import(/* webpackMode: "eager", webpackExports: ["ImageSplitter"] */ "/vercel/path0/app/components/ImageSplitter.tsx");
